import React, { useRef, useEffect } from 'react';
import { Box, Drawer, Typography, Divider, CircularProgress } from '@mui/material';
import CalendarShifts from './CalendarShifts';
import CalendarEvents from './CalendarEvents';
import { CalendarContext } from '../context/CalendarContext';
import { useContext } from 'react';


const CalendarDrawer = ({ drawerOpen, toggleDrawer }) => {
  const { calendarErrors: errors, calendarWarnings: warnings, loadingCalendarEvents: loading } = useContext(CalendarContext);
  // Referencia al contenedor scrollable
  const containerRef = useRef(null);

  // Resetear scroll al abrir o cambiar notificaciones
  useEffect(() => {
    if (drawerOpen && containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [drawerOpen, errors, warnings]);

  return (
    <Drawer
      variant="persistent"
      anchor="right"
      open={drawerOpen}
      sx={{
        '& .MuiDrawer-paper': {
          width: '350px',
          boxSizing: 'border-box',
          top: '64px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          paddingBottom: '16px',
          overflowY: 'auto', // Permite scroll si hay muchos mensajes
          maxHeight: 'calc(100vh - 64px)', // Evita que el drawer crezca demasiado
        },
      }}
    >
      {/* Contenedor principal con ref para scroll */}
      <Box ref={containerRef} sx={{ flex: 1, overflowY: 'auto' }}>
        {/* Sección de Notificaciones */}
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
            Eventos
          </Typography>
          <Divider sx={{ my: 2 }} />

        {/* Loader mientras carga */}
        {loading ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}>
              <CircularProgress sx={{ mb: 2 }} />
              <Typography variant="body2" color="text.secondary">
                Cargando alertas...
              </Typography>
            </Box>
          ) : (
            <>

          <CalendarEvents />
          </>
             )}
        </Box>

        {/* Sección de Turnos */}
        <Box sx={{ p: 2, mt: 'auto', mb: 5 }}>
          <Divider sx={{ my: 2 }} />
          <CalendarShifts />
        </Box>
      </Box>
    </Drawer>
  );
};

export default CalendarDrawer;
